
































import { Component, Vue } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import BookingComponent from '@/components/common/BookingComponent.vue';
import router from '@/router';
import AuthModule from '@/store/AuthModule';
import { postCreditRequest } from '@/api/api';
import DataRequestComponent from '@/components/prescriber/DataRequestComponent.vue';

@Component({
    components: {
        DataRequestComponent
    },
})
export default class DataRequest extends Vue {
}
